declare global {
  interface Window {
    __env?: Record<string, string>
  }
}

function env(key: string, fallback = ''): string {
  return window.__env?.[key] || (import.meta.env[`VITE_${key}`] as string) || fallback
}

export const config = {
  authUrl: env('AUTH_URL', 'http://localhost:5001'),
  authFrontUrl: env('AUTH_FRONT_URL', 'http://localhost:5174'),
  authClientId: env('AUTH_CLIENT_ID', ''),
  redirectUri: env('REDIRECT_URI', typeof window !== 'undefined' ? `${window.location.origin}/auth/callback` : ''),
  grafanaUrl: env('GRAFANA_URL', ''),
  apiUrl: env('API_URL', ''),
}
